import React from "react";

const Messenger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    <g data-name="Group 4663">
      <g data-name="Group 4657">
        <circle cx="14" cy="14" r="14" data-name="Ellipse 3" fill="#eee" />
      </g>
      <path
        d="M14.018 6A7.73 7.73 0 006 13.76a7.584 7.584 0 002.518 5.74c.27.242.214.383.26 1.879a.643.643 0 00.664.62.635.635 0 00.235-.054c1.707-.751 1.729-.811 2.018-.732 4.945 1.361 10.3-1.8 10.3-7.453A7.7 7.7 0 0014.018 6zm4.814 5.972L16.477 15.7a1.206 1.206 0 01-1.664.372c-.025-.016-.05-.034-.075-.052l-1.873-1.4a.485.485 0 00-.581 0l-2.528 1.917a.38.38 0 01-.552-.505l2.355-3.728a1.206 1.206 0 011.663-.373l.076.052 1.873 1.4a.483.483 0 00.58 0l2.53-1.915a.379.379 0 01.551.5z"
        data-name="Path 526"
      />
    </g>
  </svg>
);

export default Messenger;
